import { FunctionalComponent, h } from 'preact';
import { PaymentMode, PaymentState } from '../../../helpers/use-payments-helper';
import { i18nKeyValue } from '../../../i18n/strings/types';
import { ControlWrapper } from '../../control-wrapper';

interface Props {
    upiRegistrationFlowVariant: UpiRegistrationFlowVariant | null | undefined;
    langStrings: i18nKeyValue;
    onClickUpiBannerClick: () => void;
    hasUpiAutopayPaymentFailures?: boolean;
}

export enum UpiRegistrationFlowVariant {
    PRIMARY = 'PRIMARY',
    BACKUP = 'BACKUP',
}

export const UpiAutopayBanner: FunctionalComponent<Props> = (props: Props) => {
    const {
        upiRegistrationFlowVariant,
        langStrings,
        onClickUpiBannerClick,
        hasUpiAutopayPaymentFailures,
    } = props;

    const isBackup = upiRegistrationFlowVariant === UpiRegistrationFlowVariant.BACKUP;
    const bannerMessage = isBackup ? langStrings?.Paymentsuccess_UPISetup_backupbanner_message1 : langStrings?.Paymentsuccess_UPISetup_primarybanner_message1;
    const [bannerMessageBefore, bannerMessageAfter] = (bannerMessage ?? '').split('UPI');
    const bannerMessageWithUpiImg = (
        <span>
            {bannerMessageBefore}
            <img src="/assets/images/upi-black.svg" alt="UPI" />
            {bannerMessageAfter}: 
        </span>
    );
    const shouldShowBackupBanner = (upiRegistrationFlowVariant !== null && upiRegistrationFlowVariant !== undefined);
    const shouldShowPaymentFailureText = !shouldShowBackupBanner && hasUpiAutopayPaymentFailures !== undefined && hasUpiAutopayPaymentFailures;

    return (
        <div className="banner">
            <img src="/assets/images/upi-banner-bg.png" class="banner" alt="UPI" />

            <div className="banner-container"
                onClick={onClickUpiBannerClick}>

                <div className="banner-text">
                    {langStrings.upi_ap_homepage_trust_seal.replace('XXX', '15000+').toUpperCase()}
                </div>
                <div className="data-container">
                    <ControlWrapper shouldShow={shouldShowPaymentFailureText}>
                        <div className="title-text">
                            <img className="payment-failure-warning-icon" src="/assets/images/warning.svg" alt="Warning" />
                            <span className="payment-failure-text">
                                {langStrings?.Paymentsuccess_UPISetup_backupbanner_payment_failure_message}
                            </span>
                        </div>
                    </ControlWrapper>
                    <ControlWrapper shouldShow={shouldShowBackupBanner}>
                        <div className="title-text">
                            {bannerMessageWithUpiImg}
                            <div className="pending-text-container">
                                <img className="warning-icon" src="/assets/images/warning.svg" alt="Warning" /> {langStrings?.Paymentsuccess_UPISetup_backupbanner_message2}
                            </div>
                        </div>
                    </ControlWrapper>
                </div>
                <div className="cta-parent-container">
                    <div className="cta-container">
                        <span className="cta">
                            {shouldShowPaymentFailureText ? langStrings?.Paymentsuccess_UPISetup_backupbanner_payment_failure_retry_cta : langStrings?.upi_ap_banner_cta}
                        </span>
                    </div>
                </div>
                <div className="marquee-container">
                    <div className="marquee-content">
                        <span className="bottom-text">
                            {langStrings?.upi_ap_banner_ticker_1} &nbsp;&nbsp;•&nbsp;&nbsp; {langStrings?.upi_ap_banner_ticker_2} &nbsp;&nbsp;•&nbsp;&nbsp; {langStrings?.upi_ap_banner_ticker_3}
                        </span>
                    </div>
                </div>
            </div>

        </div >
    );
};
